var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('p',[_vm._v("Copyright 2020-2030 中国青年创业就业基金会 版权所有 京ICP备16021889号")]),_c('p',[_vm._v("技术支持：智德万通（北京）科技有限公司 联系电话：13901197016")])])
}]

export { render, staticRenderFns }